/**
 * Creates a cropped version of an image
 */
export const getCroppedImg = async (
    imageSrc: string,
    pixelCrop: { x: number; y: number; width: number; height: number }
): Promise<{ url: string; blob: Blob }> => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx) {
        throw new Error('No 2d context');
    }

    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
    );

    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (!blob) {
                reject(new Error("Canvas is empty"));
                return;
            }

            (blob as any).name = "profile.jpg";

            const url = URL.createObjectURL(blob);
            resolve({ blob, url });
        }, 'image/jpeg', 0.95);
    });
};


/**
 * Creates an image element from a source
 */
const createImage = (url: string): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', (error) => reject(error));
        image.src = url;
    });

/**
 * Converts a File to a data URL
 */
export const fileToDataUrl = (file: File): Promise<string> => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.readAsDataURL(file);
    });
};

/**
 * Formats the image data for upload to the server
 */
export const prepareImageForUpload = async (
    croppedImageUrl: string
): Promise<Blob> => {
    // Fetch the cropped image blob from the object URL
    const response = await fetch(croppedImageUrl);
    const blob = await response.blob();
    return blob;
};